export const ACTION_TYPES = {
    LOGIN: "LOGIN",
    LOGOUT: "LOGOUT",
    SIGNUP: "SIGNUP",
    ADDTAG: "ADDTAG",
    DELETETAG: "DELETETAG",
    CLEARTAG:"CLEARTAG"
}
